export default function transformColumns(columns) {
    return columns.map(c => ({
        name: c.name,
        meta: {
            name: {
                'default': c.name,
                key: c.name
            },
            slug: c.slug,
            visibility: c.visible ? 0 : 1
        }
    }));
};